import clsx from 'clsx';
import { Plus } from 'lucide-react';

const AddButton = ({ isLoading, onClick, label }) => {
    return (
        <button
            className={clsx('inline-flex items-center px-4 py-2', 'bg-[#50A1CA] hover:bg-[#50A1CA]/90', 'text-white rounded-lg', 'transition-colors duration-200', isLoading && 'opacity-50 cursor-not-allowed')}
            disabled={isLoading}
            onClick={onClick}
        >
            <Plus className="w-5 h-5 mr-2 stroke-2" />
            {label}
        </button>
    );
};

export default AddButton;
